/**
 * Hover Preloader Counter
 *
 * A static counter to keep track of the number of times a route with transition id is hovered
 * on via an element. This is used to send analytics events when the hover preloader is triggered.
 * This will help determine if we need to add any logic to cache the preloaded content as its being
 * called too many times.
 */
export class HoverPreloaderCounter {
	private static counter: Map<string, number> = new Map<string, number>();

	public static incrementHoverCounter = (name: string) => {
		if (HoverPreloaderCounter.counter.has(name)) {
			HoverPreloaderCounter.counter.set(name, HoverPreloaderCounter.counter.get(name)! + 1);
		} else {
			HoverPreloaderCounter.counter.set(name, 1);
		}
	};
	public static getHoverCounter = (name: string) => {
		return HoverPreloaderCounter.counter.get(name) || 0;
	};

	public static clearHoverCounter = (name: string) => {
		HoverPreloaderCounter.counter.delete(name);
	};
}
